interface InvoicedAmountCalculatorInput {
  base_amount: string;
  addition: string;
  deduction: string;
}

export const calculateInvoicedAmount = ({
  base_amount,
  addition,
  deduction,
}: InvoicedAmountCalculatorInput) => {
  const parsedBaseAmount = parseFloat(base_amount || "0");
  const parsedAddition = parseFloat(addition || "0");
  const parsedDeduction = parseFloat(deduction || "0");

  return parseFloat(
    (parsedBaseAmount + parsedAddition - parsedDeduction).toFixed(2),
  );
};
